import { useState } from 'react';
import { BatchPanelPage } from '../components/BatchPanelPage';
import { PublishDialog } from '../components/PublishDialog';

export function SalesPublishPage() {
  const [isPublishing, setIsPublishing] = useState(false);

  return (
    <BatchPanelPage
      stage="sales"
      title="Sales Publish Panel"
      emptyMessage="No batch has been published yet"
      createAction={{
        label: 'Publish',
        mobileLabel: 'Publish',
        onClick: () => setIsPublishing(true),
      }}
    >
      <PublishDialog open={isPublishing} onOpenChange={setIsPublishing} />
    </BatchPanelPage>
  );
}
